import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'zwi-nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styles: [
    `
      :host.android {
        margin-top: -12px;
      }
    `,
  ],
  styleUrls: ['./nav-tabs.component.scss'],
  standalone: false,
})
export class NavTabsComponent implements OnInit {
  @Input() menuItems: { name: string; icon: string; path: string }[] = [];
  @HostBinding('class.android') isAndroid =
    Capacitor.getPlatform() === 'android';

  constructor() {}

  ngOnInit(): void {}
}
